module.exports = __webpack_public_path__ + "img/persona4.3cca7a09.webp";